import request from '@/utils/request';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { endpoints, collectionEndpoint } from '@/constants/urls';

const collections = (filter, page, pageSize, orderBy) => {
  const params = { filter, page, pageSize };

  if (orderBy) {
    params.orderBy = orderBy;
  }

  return (
    request({
      url: endpoints.COLLECTIONS,
      params,
      method: 'GET',
    })
  );
};

const collection = (code) => request({
  url: collectionEndpoint(code),
  method: 'GET',
});

const create = ({
  code, name, description,
}) => {
  const data = {
    code,
    name,
    description,
  };

  if (!hasMinimumLength(data.code)) {
    delete data.code;
  }

  return request({
    url: endpoints.COLLECTIONS,
    data,
    method: 'POST',
  });
};

const update = (code, properties) => request({
  url: collectionEndpoint(code),
  data: properties,
  method: 'PATCH',
});

const destroy = ({ code }) => request({
  url: collectionEndpoint(code),
  method: 'DELETE',
});

const CollectionsService = {
  collections,
  collection,
  create,
  update,
  destroy,
};

export default CollectionsService;
